import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const Label = styled.strong.withConfig({
  displayName: "EndpointParameter__Label",
  componentId: "sc-8zy1v7-0"
})(["font-size:14px;font-weight:500;"]);
const typeToSchemaTypeI18nKey = {
  string: 'developer-docs-shared-components.params.body.types.string',
  'list(long)': 'developer-docs-shared-components.params.body.types.listOfLong',
  list: 'developer-docs-shared-components.params.body.types.list',
  long: 'developer-docs-shared-components.params.body.types.long',
  boolean: 'developer-docs-shared-components.params.body.types.boolean',
  file: 'developer-docs-shared-components.params.body.types.file',
  jsonString: 'developer-docs-shared-components.params.body.types.jsonString',
  integer: 'developer-docs-shared-components.params.body.types.integer'
};
const EndpointParameter = props => {
  const {
    name,
    required
  } = props;
  const typeI18nKey = props.schemaGroup && props.type && typeToSchemaTypeI18nKey[props.type];
  return /*#__PURE__*/_jsxs(UIFlex, {
    className: "params-pair",
    children: [/*#__PURE__*/_jsx("div", {
      className: "params-descriptor-wrapper",
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          wordBreak: 'break-word'
        },
        className: "params-descriptor",
        children: [/*#__PURE__*/_jsxs(Label, {
          children: [name, required ? '*' : '']
        }), typeI18nKey && /*#__PURE__*/_jsx(Small, {
          use: "help",
          className: "display-block",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: typeI18nKey
          })
        }), /*#__PURE__*/_jsx(Small, {
          use: "help",
          className: "display-block",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `developer-docs-shared-components.params.body.schemaGroup.${props.schemaGroup || props.type}Params`
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "params-content",
      children: /*#__PURE__*/_jsx("div", {
        children: props.children
      })
    })]
  });
};
export default EndpointParameter;